import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import notificationAnalyticsActions from '../../../../store/analyticsStores/notificationAnalyticsStore/notificationAnalyticsActions';
import NotificationAnalytics from './components/NotificationAnalytics/NotificationAnalytics';
import { PENDING } from '../../../../store/globalStatuses/globalStatuses';

export default function NotificationAnalyticsContainer() {
    const dispatch = useDispatch();
    const { data, status } = useSelector(state => state.notificationAnalyticsReducer);
    const { info } = useSelector(state => state.branchReducer);

    useEffect(() => {
        if (info?.id) {
            dispatch(notificationAnalyticsActions.getAutoNotificationAnalytics(info.id));
        }
    }, [info?.id, dispatch]);

    return (
        <NotificationAnalytics
            data={data}
            isLoading={status === PENDING}
        />
    );
}
